import BulletPoint from './bullet'
import CallIcon from './call'
import ChefIcon from './chef'
import ChevronDown from './chevron'
import ClockIcon from './clock'
import CopyIcon from './copy'
import ExclamationIcon from './exclamation'
import FacebookIcon from './facebook'
import InstagramIcon from './instagram'
import LinkArrowRight from './link-arrow'
import LinkedinIcon from './linkedin'
import NavigateIcon from './navigate'
import TiktokIcon from './tiktok'
import UserIcon from './user'
import WhatsappIcon from './whatsapp'
import XIcon from './x'
import YoutubeIcon from './youtube'

const icons = {
  facebook: FacebookIcon,
  instagram: InstagramIcon,
  linkedin: LinkedinIcon,
  tiktok: TiktokIcon,
  whatsapp: WhatsappIcon,
  x: XIcon,
  youtube: YoutubeIcon,
  linkArrowRight: LinkArrowRight,
  call: CallIcon,
  copy: CopyIcon,
  navigate: NavigateIcon,
  ['chef-hat']: ChefIcon,
  chef: ChefIcon,
  clock: ClockIcon,
  user: UserIcon,
  ['person']: UserIcon,
  bullet: BulletPoint,
  exclamation: ExclamationIcon,
  ['chevron-down']: ChevronDown,
  chevronDown: ChevronDown,
}

export default icons
